import SelectPlaceholder from "./select-placeholder";
import Init from "./init";
import Toast from "./toast";
import Location from "./location";

const Middleware = (app) => {
  app.setup(SelectPlaceholder).use(Init).use(Toast).use(Location);
};

export default Middleware;
